import { create } from "zustand"

interface FormState {
  values: any | null
  setValues: (newState: any) => void
}

const useFormValuesStore = create<FormState>((set) => ({
  values: null,
  setValues: (newState) =>
    set((state: any) => {
      return {
        ...state,
        values: { ...newState },
      }
    }),
}))

export default useFormValuesStore

